module.exports = __webpack_public_path__ + "img/slim.36532457.png";